module.exports = __webpack_public_path__ + "img/display_eye.2a4001ad.svg";